import { render, staticRenderFns } from "./Parent.vue?vue&type=template&id=179a4f89&scoped=true&"
import script from "./Parent.vue?vue&type=script&lang=js&"
export * from "./Parent.vue?vue&type=script&lang=js&"
import style0 from "./Parent.vue?vue&type=style&index=0&id=179a4f89&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179a4f89",
  null
  
)

export default component.exports